export const FUSO_PADRAO = 'America/Sao_Paulo';

type Data = Date | string;

// Partes da data no fuso informado, por tipo (day, month, year, hour, minute, weekday).
function partes(data: Data, opcoes: Intl.DateTimeFormatOptions, fuso: string) {
  const formato = new Intl.DateTimeFormat('pt-BR', { ...opcoes, timeZone: fuso, hour12: false });
  const lista = formato.formatToParts(new Date(data));
  return Object.fromEntries(lista.map((p) => [p.type, p.value])) as Record<Intl.DateTimeFormatPartTypes, string>;
}

export function formatarData(data: Data, fuso = FUSO_PADRAO) {
  const p = partes(data, { day: '2-digit', month: '2-digit', year: 'numeric' }, fuso);
  return `${p.day}/${p.month}/${p.year}`;
}

export function formatarDataHora(data: Data, fuso = FUSO_PADRAO) {
  const opcoes = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' } as const;
  const p = partes(data, opcoes, fuso);
  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}`;
}

/** Formato curto das referências visuais: "19 out". */
export function formatarDiaMes(data: Data, fuso = FUSO_PADRAO) {
  const p = partes(data, { day: 'numeric', month: 'short' }, fuso);
  return `${p.day} ${p.month.replace('.', '')}`;
}

export function formatarDiaSemana(data: Data, fuso = FUSO_PADRAO) {
  return partes(data, { weekday: 'long' }, fuso).weekday;
}
